export default "dist/images/block-feature-overlap-shape.7fd28c9.png";